/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */
import React from 'react';
import { decorate, computed, action, observable, runInAction } from 'mobx';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';

import { displayError, displaySuccess } from '@amzn/base-ui/dist/helpers/notification';

const iconStyle = { lineHeight: 1, height: '1em', margin: 0 };

class KeyPairButtons extends React.Component {
  constructor(props) {
    super(props);
    runInAction(() => {
      this.processingButton = '';
      this.confirmOpen = false;
    });
  }

  get keyPair() { return this.props.keyPair; }
  get keyPairsStore() { return this.props.keyPairsStore; }

  handleDelete = async () => {
    this.processingButton = 'delete';
    this.confirmOpen = false;
    try {
      const name = this.keyPair.name;
      await this.keyPairsStore.deleteKeyPair(this.keyPair.id);
      displaySuccess(`The key "${name}" was successfully deleted`);
    } catch (error) {
      displayError(error);
    } finally {
      runInAction(() => { this.processingButton = ''; });
    }
  };

  openConfirm = () => { this.confirmOpen = true; };
  closeConfirm = () => { this.confirmOpen = false; };

  render() {
    const processing = !!this.processingButton;

    return (
      <>
        <button
          className="workspace-action-btn workspace-action-btn-terminate"
          onClick={this.openConfirm}
          disabled={processing}
        >
          {processing ? <Icon name="spinner" loading style={iconStyle} /> : <Icon name="trash alternate" style={iconStyle} />}
          {' '}Delete
        </button>

        {this.confirmOpen && (
          <div className="rmit-modal-overlay">
            <div className="rmit-modal">
              <div className="rmit-modal-icon rmit-modal-icon-error">
                <i className="trash alternate icon" />
              </div>
              <h2 className="rmit-modal-title">Delete SSH Key?</h2>
              <p className="rmit-modal-text">
                Are you sure you want to delete <strong>{this.keyPair.name}</strong>? This action cannot be undone.
              </p>
              <div className="rmit-modal-actions">
                <button className="rmit-modal-btn rmit-modal-btn-secondary" onClick={this.closeConfirm}>
                  Cancel
                </button>
                <button
                  className="rmit-modal-btn"
                  style={{ background: '#dc2626', color: '#fff' }}
                  onClick={this.handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

decorate(KeyPairButtons, {
  keyPair: computed,
  keyPairsStore: computed,
  processingButton: observable,
  confirmOpen: observable,
  handleDelete: action,
  openConfirm: action,
  closeConfirm: action,
});

export default inject('keyPairsStore')(withRouter(observer(KeyPairButtons)));
